"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _get = _interopRequireDefault(require("lodash/get"));
var _ReduxField = _interopRequireDefault(require("./ReduxField"));
var _BrixelInputText = _interopRequireDefault(require("./BrixelInputText"));
var _ReduxForm = require("../../utils/ReduxForm.Functions");
var Validation = _interopRequireWildcard(require("../../utils/validation.helper"));
var _translation = _interopRequireDefault(require("../../Translation/translation"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BrixelLogin = props => {
  const {
    errorValue,
    formName = 'login',
    formValue,
    lang = 'en',
    showErrors = false,
    translations
  } = props;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ReduxField.default, {
    input: {
      disableDelay: false,
      name: 'login.email',
      placeholder: 'example@brixel.io',
      type: 'email',
      validate: [Validation.isEmail, Validation.required]
    },
    labels: {
      label: (0, _translation.default)('Email address', lang, undefined, translations)
    },
    design: {
      className: 'mt-2',
      large: true
    },
    form: formName,
    component: _BrixelInputText.default,
    meta: {
      dirty: (0, _get.default)(formValue, 'login.email', null),
      invalid: (0, _get.default)(errorValue, 'login.email', true) !== true || showErrors,
      message: {
        error: (0, _translation.default)('Please insert a valid email', lang, undefined, translations)
      },
      showErrors
    }
  }), /*#__PURE__*/_react.default.createElement(_ReduxField.default, {
    input: {
      disableDelay: false,
      name: 'login.password',
      placeholder: '',
      type: 'password',
      validate: [Validation.minLength(5), Validation.required]
    },
    labels: {
      label: (0, _translation.default)('Password', lang, undefined, translations)
    },
    design: {
      className: 'mt-2',
      large: true
    },
    form: formName,
    component: _BrixelInputText.default,
    meta: {
      dirty: (0, _get.default)(formValue, 'login.password', null) || showErrors,
      invalid: (0, _get.default)(errorValue, 'login.password', true) !== true || showErrors,
      message: {
        error: (0, _translation.default)('Please insert a valid password', lang, undefined, translations)
      },
      showErrors
    }
  }));
};
const mapStateToProps = (state, ownProps) => {
  const formName = ownProps.formName || 'login';
  return {
    errorValue: (0, _get.default)(state, `brixelForm[${formName}].syncErrors`, {}),
    formValue: (0, _get.default)(state, `brixelForm[${formName}].values`, {}),
    translations: (0, _get.default)(state, 'translations', {})
  };
};
const mapDispatchToProps = dispatch => ({
  handleChangeSyncError(field, value) {
    dispatch((0, _ReduxForm.changeSyncError)('LoginForm', field, value));
  }
});
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BrixelLogin);